/* ============================================
   SMITH'S BLADES — THEME.JS
   v1.0 | Cronix Solutions
   ============================================ */

(function () {
  'use strict';

  /* ——————————————————————————————————————
     1. NAV SCROLL
     —————————————————————————————————————— */
  var nav = document.getElementById('mainNav');

  if (nav) {
    window.addEventListener('scroll', function () {
      if (window.scrollY > 50) {
        nav.classList.add('scrolled');
      } else {
        nav.classList.remove('scrolled');
      }
    }, { passive: true });
  }

  /* ——————————————————————————————————————
     2. SCROLL REVEAL
     —————————————————————————————————————— */
  var revealElements = document.querySelectorAll('.reveal');

  if (revealElements.length > 0) {
    var revealObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
        }
      });
    }, { threshold: 0.15 });

    revealElements.forEach(function (el) {
      revealObserver.observe(el);
    });
  }

  /* ——————————————————————————————————————
     3. PARTICLE ANIMATION
     Exact match of reference HTML
     —————————————————————————————————————— */
  var canvas = document.getElementById('particles-canvas');

  if (canvas) {
    var ctx = canvas.getContext('2d');
    var particles = [];
    var W, H;

    function resizeCanvas() {
      W = canvas.width  = window.innerWidth;
      H = canvas.height = window.innerHeight;
    }
    resizeCanvas();
    window.addEventListener('resize', resizeCanvas);

    /* ---- Particle class matching reference exactly ---- */
    function Particle() {
      this.reset();
    }

    Particle.prototype.reset = function () {
      this.x       = Math.random() * W;
      this.y       = Math.random() * H;
      this.size    = Math.random() * 1.8 + 0.3;
      this.speedX  = (Math.random() - 0.5) * 0.3;
      this.speedY  = -(Math.random() * 0.5 + 0.2);
      this.opacity = Math.random() * 0.6 + 0.1;
      this.life    = 0;
      this.maxLife = Math.random() * 200 + 100;
      this.type    = Math.random() > 0.85 ? 'spark' : 'ember';

      if (this.type === 'spark') {
        this.speedY *= 2;
        this.size    = Math.random() * 1 + 0.5;
      }
    };

    Particle.prototype.update = function () {
      this.x    += this.speedX;
      this.y    += this.speedY;
      this.life += 1;

      /* Reset when life expires or flies off top */
      if (this.life > this.maxLife || this.y < -10) {
        this.reset();
      }

      this.opacity = (1 - this.life / this.maxLife) * 0.6;
    };

    Particle.prototype.draw = function () {
      if (this.type === 'spark') {
        ctx.beginPath();
        ctx.strokeStyle = 'rgba(245,217,128,' + (this.opacity * 0.9) + ')';
        ctx.lineWidth   = this.size * 0.5;
        ctx.moveTo(this.x, this.y);
        ctx.lineTo(
          this.x - this.speedX * 6,
          this.y - this.speedY * 4
        );
        ctx.stroke();
      } else {
        ctx.beginPath();
        ctx.arc(this.x, this.y, this.size, 0, Math.PI * 2);
        var r = Math.floor(201 + (Math.random() - 0.5) * 30);
        var g = Math.floor(168 + (Math.random() - 0.5) * 20);
        var b = Math.floor(76  + (Math.random() - 0.5) * 20);
        ctx.fillStyle = 'rgba(' + r + ',' + g + ',' + b + ',' + this.opacity + ')';
        ctx.fill();
      }
    };

    /* ---- Seed exactly like reference HTML ---- */
    /* "Seed more near bottom (forge embers rising)" */
    for (var i = 0; i < 120; i++) {
      var p    = new Particle();
      /* Start in bottom 40% of screen */
      p.y      = Math.random() * H * 0.4 + H * 0.6;
      /* Give each particle a random life stage so they
         are spread across all phases on first render —
         this is what makes them appear across full height */
      p.life   = Math.random() * p.maxLife;
      particles.push(p);
    }

    /* ---- Animation loop ---- */
    function animateParticles() {
      ctx.clearRect(0, 0, W, H);
      particles.forEach(function (p) {
        p.update();
        p.draw();
      });
      requestAnimationFrame(animateParticles);
    }

    animateParticles();
  }

  /* ============================================
     ABOUT PAGE — Scroll Reveal
     ============================================ */
  var aboutRevealEls = document.querySelectorAll('.about-reveal');
  if (aboutRevealEls.length > 0) {
    var aboutObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('about-visible');
          aboutObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12 });

    aboutRevealEls.forEach(function (el) {
      aboutObserver.observe(el);
    });
  }

})();